import Backstage from 'interfaces/Backstage.interface';
import NftData from 'interfaces/NftData.interface';
import { UserData } from 'interfaces/UserData.interface';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export enum ResultType {
  user = 0,
  post = 1,
  nft = 2,
}

interface ResultRowProps {
  avatar: string;
  title: string;
  desc: string;
  isUser: boolean;
  type: ResultType;
  post?: Backstage;
  nft?: NftData;
  user?: UserData;
}

const ResultRow = ({
  avatar,
  title,
  desc,
  isUser,
  type,
  post,
  user,
  nft,
}: ResultRowProps) => {
  const navigate = useNavigate();

  const returnPath = (type: ResultType) => {
    switch (type) {
      case ResultType.user:
        return `/profile/${user?.username}/feed`;
      case ResultType.nft:
        return `/explore/${nft?.id}`;
      case ResultType.post:
        return `/profile/${post?.user?.username}/backstage`;
    }
  };
  return (
    <li onClick={() => navigate(returnPath(type))} className="result-row">
      <img
        style={{ borderRadius: isUser ? '50%' : '25px' }}
        src={avatar}
        alt=""
      />
      <div>
        <h4>{title}</h4>
        <span>{desc}</span>
      </div>
    </li>
  );
};

export default ResultRow;
